import Vue from 'vue'
import Router from 'vue-router'
// import Home from '../views/Home.vue'
const Builder = () => import('@/views/Builder.vue');
const DockBuilder = () => import('@/views/DockBuilder.vue');
const BuilderList = () => import('@/views/BuilderList.vue');
const Board = () => import('@/views/Board.vue');
const CallBack = () => import('@/views/CallBack.vue');

import conf from'@/config/config';
const LoginUrl = conf.loginurl;


import store from '@/store/store';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Builder,
      beforeEnter (to, from, next) {
        console.log(store.state);
        store.dispatch('fetchUser');
        if (store.state.account.Uid) {
          next();
        } else {
          store.dispatch('setReturnUrl', to.fullPath);
          window.location.href = LoginUrl;
        }
      }
    },
    {
      path: '/builder',
      name: 'builder',
      component: Builder,
      beforeEnter (to, from, next) {
        store.dispatch('fetchUser');
        if (store.state.account.Uid) {
          next();
        } else {
          store.dispatch('setReturnUrl', to.fullPath);
          window.location.href = LoginUrl;
        }
      }
    },
    {
      path: '/dockbuilder',
      name: 'dockbuilder',
      component: DockBuilder,
      beforeEnter (to, from, next) {
        store.dispatch('fetchUser');
        if (store.state.account.Uid) {
          next();
        } else {
          store.dispatch('setReturnUrl', to.fullPath);
          window.location.href = LoginUrl;
        }
      }
    },
    {
      path: '/builderlist',
      name: 'builderlist',
      component: BuilderList,
      beforeEnter (to, from, next) {
        store.dispatch('fetchUser');
        if (store.state.account.Uid) {
          next();
        } else {
          store.dispatch('setReturnUrl', to.fullPath);
          window.location.href = LoginUrl;
        }
      }
    },
    {
      path: '/board',
      name: 'board',
      component: Board
    },
    {
      path: '/board/:boardId',
      name: 'board',
      component: Board
    },
    {
      path: '/callback',
      name: 'CallBack',
      component: CallBack,
      meta: {
        title: "callback login"
      },
      beforeEnter (to, from, next) {
        store.dispatch('fetchUser');
        store.dispatch('fetchReturnUrl');
        if (!store.state.account.Uid) {
          next();
        } else {
          next('/builder');
        }
      }
    }
  ]
})
